import React, {
  Suspense,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { connect } from "react-redux";
import API from "Api";
import {
  isLoggedIn,
  protectedRoute,
  getLocalStorage,
  setLocalStorage,
  clearAuthInfoFromLocalStorage,
  logoutUser,
} from "utils/generalUtils";
import PageLoading from "Components/Common/PageLoading";
import NotificationManager from "Hooks/NotificationManager";
import PageNotFound from "Container/PageNotFound";
import {
  START_GET_LOGIN_USER,
  START_GET_REFRESHTOKEN,
} from "Actions/UserAction";
import { LOGOUT_START } from "Actions/AuthAction";
import { Backdrop, CircularProgress } from "@mui/material";
import Login from "Container/Auth/Login";
import ForgotPassword from "Container/Auth/ForgotPassword";
import ResetPassword from "Container/Auth/ResetPassword";
import CreatePharmacyPassword from "Container/Auth/CreatePharmacyPassword";
import { sidebarMenuItems } from "utils/data";
import { SET_HEADER_FILTER_PHARMACIES } from "Actions/PharmacyAction";
import OrderCreateAndUpdateMain from "Container/OrderCreateAndUpdate";
import Collection from "Container/Collection";
import ActivityLog from "Container/ActivityLog";
// import Algorithm from "Container/Algorithm";
import ImportCsv from "Container/ImportCsv";
import Home from "Container/Home";
import Pharmacies from "Container/Pharmacies";
import Surgeries from "Container/Surgery";
import Staffs from "Container/Staffs";
import Groups from "Container/Groups";
import Patients from "Container/Patients";
import RepeatOrder from "Container/RepeatOrder";
import GlobalSetting from "Container/GlobalSetting";
import { START_GET_PATIENT_LIST } from "Actions/PatientAction";
import { START_GET_REPEAT_ORDER_LIST } from "Actions/RepeatOrderAction";
import { START_GET_GROUP_LIST } from "Actions/GroupAction";
import { START_GET_STAFF_LIST } from "Actions/StaffAction";
import { START_GET_PHARMACIES_LIST } from "Actions/PharmacyAction";
import { START_GET_SURGERY_LIST } from "Actions/SurgeryAction";
import { START_GET_COLLECTION_LIST } from "Actions/CollectionAction";
import {
  START_CHASEUP_CHART,
  START_GET_HOME_LIST,
  START_ORDER_CHART,
} from "Actions/HomeAction";
import { START_GET_NO_OF_ALERT } from "Actions/HomeAction";
import { START_GLOBAL_SETTING } from "Actions/RepeatOrderAction";
import useHeaderPharmacySelection from "Hooks/useHeaderPharmacySelection";
import { START_ORDER_SPEED } from "Actions/OrderPadAction";
import HowTo from "Container/HowTo";
import PharmasmartLogin from "Container/Auth/PharmasmartLogin";
import PaymentListMain from "Components/Common/PaymentMain/PaymentListMain";
import PaymentLog from "Container/PaymentLog";
import ImportDuplicateMain from "Components/ImportDuplicate/ImportDuplicateMain";
import ImportDuplicate from "Container/ImportDuplicate";
import ContainerWrapper from "Container/ContainerWrapper";
import { useActivityTracker, debounce } from "Hooks/customHooks";
import { useIdleTimer } from "react-idle-timer";
import { jwtDecode } from "jwt-decode";

const Main = (props) => {
  const {
    logout,
    getLoginUserAction,
    loginUserDetail,
    logoutData,
    setHeaderFileterPharmaciesAction,
    getHomeListAction,
    getGlobalSettingAction,
    getNoOfAlertAction,
    getOrderSpeedAction,
    getChaseupChartAction,
    getOrderChartAction,
    refreshTokenDetail,
    getRefreshTokenAction,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const path = location.pathname.split("/")[1];
  const token = API.getAccessTokenFromLocalStorage();
  const [showBackdrop, setShowBackdrop] = useState(false);
  const [checkedChaseUp, setCheckedChaseUp] = React.useState(false);
  const [welcomeDialog, setWelcomeDialog] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [remainingTime, setRemainingTime] = React.useState(0);
  const [prevpath, setprevPath] = useState();
  const selectedHeaderPharmacyId = getLocalStorage("Pharmacies", true);
  // const { selectedHeaderPharmacyId } = useHeaderPharmacySelection();
  const [isEventListenerActive, setIsEventListenerActive] = useState(false);
  const [active, setActive] = useState(false);

  const Expiry = 7200000; // 2 hrs
  const LastFiveMinutes = 300000; // 5 min
  const idealThreshHold = 1800000; // 30 min

  // const Expiry = 600000; // 10 min
  // const LastFiveMinutes = 300000; // 5 min
  // const idealThreshHold = 30000; // 10 seconds

  // const Expiry = 10000; // 10 seconds
  // const LastFiveMinutes = 5000; // 5 seconds
  // const idealThreshHold = 2000; // 2 seconds

  const channel = new BroadcastChannel("idle_channel");

  const isAllowToAccessPage = () => {
    const pageDetail = sidebarMenuItems.filter((item) => {
      if (item.hasOwnProperty("sub")) {
        let selectedSubMenu = item.sub.filter((subItem) => {
          return subItem.url === currentPath;
        });
        if (selectedSubMenu.length > 0) {
          return selectedSubMenu;
        }
      } else {
        return item.url === currentPath;
      }
    });
    if (pageDetail.length > 0) {
      return loginUserDetail?.data?.data?.role === "admin"
        ? true
        : pageDetail[0].permission[loginUserDetail?.data?.data?.role] === 1;
    }
    return false;
  };

  const ref = useRef(null);

  const handleIdle = () => {
    let checkButton = JSON.parse(localStorage.getItem("LogOutFromButton"));
    if (checkButton) {
      localStorage.setItem("LogoutFromFunc", JSON.stringify(false));
    } else {
      localStorage.setItem("LogoutFromFunc", JSON.stringify(true));
    }
    setActive(false);
    logoutUser();
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "triggerIdle") {
        handleIdle();
      }
    };
    channel.addEventListener("message", handleMessage);
  }, []);

  const triggerIdleAcrossTabs = () => {
    console.log(" Trigger Function ");
    // Call handleIdle for the Other tabs
    localStorage.setItem("triggerIdle", Date.now());
    console.log(" Handle ideal for single tab ");
    // Explicitly call handleIdle for the current tab
    handleIdle();
  };

  // Auto Logout on User Inactivity(Ideal) for 2 hrs
  const {
    getRemainingTime,
    getTabId,
    isLeader,
    isLastActiveTab,
    message,
    reset,
  } = useIdleTimer({
    // onIdle: handleIdle,
    onActive: () => setActive(true),
    timeout: Expiry,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
    events: [
      "mousemove",
      "keydown",
      "wheel",
      "DOMMouseScroll",
      "mousewheel",
      "mousedown",
      "touchstart",
      "touchmove",
      "MSPointerDown",
      "MSPointerMove",
    ],
  });

  // Checks Every Second
  useEffect(() => {
    const interval = setInterval(() => {
      const idealTimeInSeconds = Math.ceil(getRemainingTime() / 1000);
      const idealTime = Expiry - getRemainingTime();
      const LastTokenRefreshedAt = parseInt(
        localStorage.getItem("LastTokenRefreshedAt"),
        10
      );
      const currentTime = Date.now();

      if (LastTokenRefreshedAt) {
        // LastTokenRefreshedAt + 2 hrs - 5 mins  < currentTime
        if (LastTokenRefreshedAt + (Expiry - LastFiveMinutes) < currentTime) {
          if (idealTime < idealThreshHold) {
            // 30 mins
            reset(); // reset the idle timer
            getRefreshTokenAction();
            return;
          } else {
            localStorage.setItem(
              "LastDailogAt",
              JSON.stringify({
                time: Date.now(),
                place: "condition",
                action: "open",
                idealTime: idealTime,
              })
            );
            setShowDialog(true); // Open 5 minute Dailog
            return;
          }
        }
        // handleIdle();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [getRemainingTime]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "triggerIdle") {
        handleIdle(); // Manually trigger onIdle when storage event is detected
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect(() => {
  //   if (isEventListenerActive) {
  // const interval = setInterval(() => {
  // getRefreshTokenAction();
  //       setIsEventListenerActive(false);
  //     }, 300000);

  //     return () => clearInterval(interval);
  //   }
  // }, [isEventListenerActive]);

  const eventListenerHandler = () => {
    // Your event listener logic here
    setIsEventListenerActive(true);
  };
  window.addEventListener("yourEvent", eventListenerHandler);
  document.addEventListener("click", function (event) {
    // Log the event target and its event listeners
    eventListenerHandler();
  });
  window.addEventListener("click", function (event) {
    eventListenerHandler();
  });
  useEffect(() => {
    if (!refreshTokenDetail?.loading) {
      if (refreshTokenDetail?.data?.data?.token) {
        // setLocalStorage("token", refreshTokenDetail?.data?.data?.token);
      }
    }
  }, [refreshTokenDetail?.loading]);

  useLayoutEffect(() => {
    setprevPath(currentPath);
    if (
      prevpath !== undefined ||
      (prevpath === "/order" && (currentPath === "/rx-collection" || currentPath === "/prescription-tracking"))
    ) {
      localStorage.removeItem("surgeryList");
    }
    if ((prevpath === "/rx-collection" || prevpath === "/prescription-tracking") && currentPath === "/order") {
      localStorage.removeItem("surgeryList");
    }
  }, [currentPath]);

  const redirectOnUnAuthPageAccess = () => {
    if (!isAllowToAccessPage()) {
      if (loginUserDetail?.data?.data?.role === "user") {
        navigate("/home");
      } else if (loginUserDetail?.data?.data?.role === "nursing") {
        navigate("/order");
      } else {
        navigate("/home");
      }
    }
  };

  useEffect(() => {
    if (token && token !== "") {
      const selectedPharmcies = getLocalStorage("Pharmacies", true);
      if (selectedPharmcies?.length > 0) {
        setHeaderFileterPharmaciesAction(selectedPharmcies[0]);
      }
    } else if (
      [
        "forgot-password",
        "reset-password",
        "pharmacy-create-password",
        "nursing-patient-list",
        "pharmsmart"
      ].includes(path)
    ) {
    } else {
      if (["login"].includes(path)) {
        navigate("login");
      } else {
        navigate("/login");
      }
    }
  }, []);

  useEffect(() => {
    if (loginUserDetail?.loading || logoutData?.isLoading) {
      setShowBackdrop(true);
    } else {
      setShowBackdrop(false);
    }
  }, [loginUserDetail, logoutData]);

  useEffect(() => {
    let payload = {
      offset: 0,
    };
    let payLoadOrder = {
      offset: 0,
      type: "today",
    };
    let payloadSurgery = {
      offset: 0,
      collection_only: false,
    };
    let payloadCollection = {
      offset: 0,
      is_chase_up: getLocalStorage("chaseUp") == "true" ? true : false,
      type: "un_collected",
    };
    if (token || token !== null) {
      if (!Object.keys(loginUserDetail?.data || {})?.length) {
        getLoginUserAction();
        if (
          location.pathname === "/home" ||
          location.pathname === "/surgery" ||
          location.pathname === "/prescription-tracking" ||
          location.pathname === "/rx-collection"
        ) {
          getGlobalSettingAction();
        }
        let payloadHome = {};
        if (
          selectedHeaderPharmacyId !== "" &&
          selectedHeaderPharmacyId !== undefined &&
          selectedHeaderPharmacyId !== "all" &&
          selectedHeaderPharmacyId !== null
        ) {
          payloadHome = {
            pharmacy_id: [selectedHeaderPharmacyId],
          };

          // getHomeListAction(payloadHome);
          // getNoOfAlertAction(payloadHome);
          setLocalStorage("Pharmacies", selectedHeaderPharmacyId);
          // getOrderSpeedAction(payloadHome);
          // getChaseupChartAction(payloadHome);
          // getOrderChartAction(payloadHome);
        } else {
          if (location.pathname !== "/order") {
            // getHomeListAction();
          }
          // getNoOfAlertAction();
          setLocalStorage("Pharmacies", "all");

          // getOrderSpeedAction();
          // getChaseupChartAction();
          // getOrderChartAction();
        }
        // getHomeListAction();
        setLocalStorage("urlhome", "home");
        setLocalStorage("urlpatient", "patients");
        setLocalStorage("urlgroup", "group");
        setLocalStorage("urlorder", "order");
        setLocalStorage("urlstaff", "staff");
        setLocalStorage("urlpharmacy", "pharmacy");
        setLocalStorage("urlsurgery", "surgery");
        setLocalStorage("urlcollection", "collection");

        setLocalStorage("pharmacyChange", false);
      } else {
        redirectOnUnAuthPageAccess();
      }
      if (protectedRoute.includes(path)) {
        navigate("/home");
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (loginUserDetail?.data?.data?.role !== undefined) {
      redirectOnUnAuthPageAccess();
    }
  }, [loginUserDetail?.data?.data?.role]);

  const routes = [
    {
      element: <Login />,
      path: "/login",
      exact: true,
      showSide: false,
    },
    {
      element: <PharmasmartLogin />,
      path: "/pharmsmart/auth/:token",
      exact: true,
      showSide: false,
    },
    {
      element: <ForgotPassword />,
      path: "/forgot-password",
      exact: true,
      showSide: false,
    },
    {
      element: <ResetPassword />,
      path: "/reset-password/:token",
      exact: true,
      showSide: false,
    },
    {
      element: <CreatePharmacyPassword />,
      path: "/pharmacy-create-password/:token",
      exact: true,
      showSide: false,
    },
    {
      element: <Home setCheckedChaseUp={setCheckedChaseUp} />,
      path: "/home",
      exact: true,
      showSide: true,
    },
    {
      element: <Pharmacies />,
      path: "/pharmacies",
      exact: true,
      showSide: true,
    },
    {
      element: <Surgeries />,
      path: "/surgery",
      exact: true,
      showSide: true,
    },
    {
      element: <Staffs />,
      path: "/staff",
      exact: true,
      showSide: true,
    },
    {
      element: <Groups />,
      path: "/groups",
      exact: true,
      showSide: true,
    },
    {
      element: <Patients />,
      path: "/patients",
      exact: true,
      showSide: true,
    },
    {
      element: <RepeatOrder />,
      path: "/order",
      exact: true,
      showSide: true,
    },
    {
      element: <OrderCreateAndUpdateMain />,
      path: "/order-pad",
      exact: true,
      showSide: true,
    },
    ...(process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true"
      ? [
        {
          element: (
            <Collection
              checkedChaseUp={checkedChaseUp}
              setCheckedChaseUp={setCheckedChaseUp}
            />
          ),
          path: "/prescription-tracking",
          exact: true,
          showSide: true,
        },
      ]
      : [
        {
          element: (
            <Collection
              checkedChaseUp={checkedChaseUp}
              setCheckedChaseUp={setCheckedChaseUp}
            />
          ),
          path: "/rx-collection",
          exact: true,
          showSide: true,
        },
      ]),
    {
      element: <ActivityLog />,
      path: "/activity",
      exact: true,
      showSide: true,
    },
    {
      element: <PaymentLog />,
      path: "/payment-log",
      exact: true,
      showSide: true,
    },
    {
      element: <ImportDuplicate />,
      path: "/duplicate-patient",
      exact: true,
      showSide: true,
    },
    // {
    //   element: <Algorithm />,
    //   path: "/algorithm",
    //   exact: true,
    // },
    {
      element: <ImportCsv />,
      path: "/import-patient",
      exact: true,
      showSide: true,
    },
    {
      element: <GlobalSetting />,
      path: "/settings",
      exact: true,
      showSide: true,
    },
    {
      element: <HowTo />,
      path: "/how-to",
      exact: true,
      showSide: true,
    },
    {
      element: <PageNotFound />,
      path: "*",
      showSide: true,
    },
  ];

  // DONT DELETE THE FOLLOWING COMMENT ---- Open Welcome Dialog useEffect ----

  // useEffect(() => {
  //   if (loginUserDetail?.data?.success) {
  //     // if (location.pathname !== "/order" && location.pathname !== "/patients" && loginUserDetail?.data?.data?.role !== "admin" && loginUserDetail?.data?.data?.role !== "super_admin") {
  //     if (loginUserDetail?.data?.data?.role !== "admin" &&
  //       loginUserDetail?.data?.data?.role !== "super_admin" &&
  //       loginUserDetail?.data?.data?.is_new_user === true &&
  //       loginUserDetail?.data?.data?.pharmacy_detail !== null &&
  //       loginUserDetail?.data?.data?.pharmacy_detail !== undefined
  //     ) {
  //       if (
  //         loginUserDetail?.data?.data?.pharmacy_detail?.tour
  //           ?.t_is_watch_introduction_video &&
  //         loginUserDetail?.data?.data?.pharmacy_detail?.tour
  //           ?.t_is_import_patient_pmr &&
  //         loginUserDetail?.data?.data?.pharmacy_detail?.tour?.t_is_create_order
  //       ) {
  //         setWelcomeDialog(false);
  //       } else {
  //         setWelcomeDialog(true);
  //       }
  //     }
  //   }
  // }, [loginUserDetail, location]);

  return (
    <>
      <Backdrop open={showBackdrop} sx={{ zIndex: "1301" }}>
        {/* <CircularProgress size={100} thickness={8} /> */}
      </Backdrop>
      <Suspense fallback={<PageLoading />}>
        <NotificationManager />
        <Routes>
          {routes.map((item, key) => {
            return (
              <Route
                key={key}
                {...item}
                element={
                  isLoggedIn() ? (
                    <>
                      {item?.showSide && (
                        <ContainerWrapper
                          welcomeDialog={welcomeDialog}
                          setWelcomeDialog={setWelcomeDialog}
                          remainingTime={remainingTime}
                          isUserActive={active}
                          showDialog={showDialog}
                          setShowDialog={setShowDialog}
                          triggerIdleAcrossTabs={triggerIdleAcrossTabs}
                        >
                          {item?.element}
                        </ContainerWrapper>
                      )}
                      {!item?.showSide && item?.element}
                    </>
                  ) : (
                    <Navigate to={"/home"} />
                  )
                }
              />
            );
          })}
        </Routes>
        <Routes>
          <Route exact path="/" element={<Navigate to={"/login"} />} />
        </Routes>
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => ({
  loginUserDetail: state.user.loginUserDetail,
  logoutData: state.auth.logoutData,
  orderSpeed: state.home.orderSpeed,
  chaseupChart: state.home.chaseupChart,
  refreshTokenDetail: state.user.refreshTokenDetail,
});
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch({ type: LOGOUT_START }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
  getRefreshTokenAction: (payload) =>
    dispatch({ type: START_GET_REFRESHTOKEN, payload }),
  setHeaderFileterPharmaciesAction: (payload) =>
    dispatch({ type: SET_HEADER_FILTER_PHARMACIES, payload }),
  getPatientListAction: (payload) =>
    dispatch({ type: START_GET_PATIENT_LIST, payload }),
  getOrderListAction: (payload) =>
    dispatch({ type: START_GET_REPEAT_ORDER_LIST, payload }),
  getSGroupListAction: (payload) =>
    dispatch({ type: START_GET_GROUP_LIST, payload }),
  getStaffListAction: (payload) =>
    dispatch({ type: START_GET_STAFF_LIST, payload }),
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_GET_PHARMACIES_LIST, payload }),
  getSurgeryListAction: (payload) =>
    dispatch({ type: START_GET_SURGERY_LIST, payload }),
  getCollectionRxAction: (payload) =>
    dispatch({ type: START_GET_COLLECTION_LIST, payload }),
  getHomeListAction: (payload) =>
    dispatch({ type: START_GET_HOME_LIST, payload }),
  getNoOfAlertAction: (payload) =>
    dispatch({ type: START_GET_NO_OF_ALERT, payload }),
  getGlobalSettingAction: () => dispatch({ type: START_GLOBAL_SETTING }),
  getOrderSpeedAction: (payload) =>
    dispatch({ type: START_ORDER_SPEED, payload }),
  getChaseupChartAction: (payload) =>
    dispatch({ type: START_CHASEUP_CHART, payload }),
  getOrderChartAction: (payload) =>
    dispatch({ type: START_ORDER_CHART, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
